import { createSelector } from '@reduxjs/toolkit';
import { StateSchema } from '../../StoreProvider/StoreProvider.types';
import { Slices } from '../slices';
import { promptsAdapter } from './slice';

/**
 * Базовые селекторы EntityAdapter
 */
const promptsSelectors = promptsAdapter.getSelectors<StateSchema>(state => state[Slices.Prompts]);

/**
 * Селектор для получения промпта по ID
 * Используется для получения кешированных промптов из store
 */
export const selectPromptById = promptsSelectors.selectById;

/**
 * Селектор для получения всех ID промптов
 * Используется для проверки наличия промпта в кеше
 */
export const selectPromptIds = promptsSelectors.selectIds;

/**
 * Селектор для проверки наличия промпта в кеше
 * Используется в usePrompt hook для оптимизации запросов
 * @param state - состояние приложения
 * @param promptId - ID промпта для проверки
 * @returns true если промпт есть в кеше
 */
export const selectIsPromptCached = createSelector(
    [selectPromptIds, (state: StateSchema, promptId: number) => promptId],
    (ids, promptId) => ids.includes(promptId),
);
